module.exports = __webpack_public_path__ + "img/Diagram.524e066d.png";